import { Injectable } from '@angular/core';
import { Dictionary, map } from 'lodash';
import {TooltipItem} from './tooltip-item';

@Injectable()
export class TooltipFormatter {
    private items: TooltipItem[] = [];

    public addTooltipItems(newItems: TooltipItem[]) : void {
        this.items = this.items.concat(newItems);
    }

    public addItems(newItems: Dictionary<string>) : void {
        this.addTooltipItems(map(newItems, (value, key) => new TooltipItem(key, value)));
    }

    public clear(): void {
        this.items = [];
    }

    public getTooltipContent(): string {
        return `<table class="tooltip-content">
                    ${map(this.items, (value) => this.getRowContent(value)).join('')}
                </table>`;
    }

    private getRowContent(item: TooltipItem): string {
        return `<tr>
                    <td class="tooltip-header ${this.escapeHtml(item.labelClass)}">${this.escapeHtml(item.labelText)}: </td>
                    <td class="${this.escapeHtml(item.contentClass)}">${this.escapeHtml(item.contentText)}</td>
                </tr>`;
    }

    private escapeHtml(unsafe: string): string {
        // escaping string based on Angular's escaping in the sanitizer (which is not public for us to call)
        return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }
}